export type MapModel =
    | "GSM"
    | "GS5"
    | "GSA"
    | "GSL"
    | "MSG"
    | "MSM"
    | "LFM"
    | "CWM"
    | "QMA";

export interface MapMeta {
    x0: number;
    y0: number;
    width: number;
    height: number;
    tileW: number;
    tileH: number;
    cropNum: readonly [number, number, number, number];
    basemap: "GPV.svg" | "GPVgl.svg";
    kmPerPx: number;
    initialView: {
        x: number;
        y: number;
        width: number;
        deg: number;
    };
}

const JP_META: MapMeta = {
    x0: -3550,
    y0: 4250,
    width: 5600,
    height: 4800,
    tileW: 700,
    tileH: 600,
    cropNum: [2, 4, 8, 16],
    basemap: "GPV.svg",
    kmPerPx: 0.5,
    // GPV-1.0/2.0 の全国presetと同じ初期画角を維持する。
    initialView: { x: -3475, y: 5098, width: 5430.58, deg: 0 },
};

const GSA_META: MapMeta = {
    x0: -8100,
    y0: 2300,
    width: 14400,
    height: 10240,
    tileW: 900,
    tileH: 640,
    cropNum: [2, 4, 8, 16],
    basemap: "GPVgl.svg",
    kmPerPx: 1,
    // GPV-NH-1.0の「南方」presetをGSAの初期画角にする。
    initialView: {
        x: -5785.035,
        y: 4223.712,
        width: 10861.16,
        deg: 0,
    },
};

const MSG_META: MapMeta = {
    ...GSA_META,
    // MSG-Lは黄砂presetを初期画角にする。
    initialView: {
        x: -5975.24,
        y: 3529.042,
        width: 8620.509,
        deg: 0,
    },
};

const GSL_META: MapMeta = {
    x0: -12800,
    y0: -12800,
    width: 25600,
    height: 25600,
    tileW: 800,
    tileH: 800,
    cropNum: [2, 4, 8, 16],
    basemap: "GPVgl.svg",
    kmPerPx: 2,
    // GPV-NH-1.0の初期画角（極東）を維持する。
    initialView: {
        x: -8056.523,
        y: -265.21,
        width: 15360,
        deg: 0,
    },
};

export const MAP_META: Record<MapModel, MapMeta> = {
    GSM: JP_META,
    GS5: JP_META,
    GSA: GSA_META,
    GSL: GSL_META,
    MSG: MSG_META,
    MSM: JP_META,
    LFM: JP_META,
    CWM: JP_META,
    QMA: JP_META,
};

export function getMapMeta(model: MapModel) {
    return MAP_META[model];
}

export function hasSameMapArea(a: MapModel, b: MapModel) {
    const left = MAP_META[a];
    const right = MAP_META[b];
    return (
        left.x0 === right.x0 &&
        left.y0 === right.y0 &&
        left.width === right.width &&
        left.height === right.height &&
        left.tileW === right.tileW &&
        left.tileH === right.tileH &&
        left.basemap === right.basemap
    );
}
